// removed by extract-text-webpack-plugin
module.exports = {"Page":"_3pJ9qmR_6VQXVcMHUsKU9m","TitleBar":"_3YAgK8HmfO-JxdW7EPxRu-","RightControls":"_3Agoo69kwYROiXB-lSnt_2"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Reports/index.css
// module id = 945
// module chunks = 0